import { useState, useEffect, useCallback } from "react";
const TIME_INTERVAL = 1000;
const useLessMinute = (time: number, action: () => void) => {
  const [seconds, setSeconds] = useState(time);
  const ticker = useCallback(() => {
    if (seconds) {
      setSeconds(seconds - 1);
    }
  }, [seconds]);

  useEffect(() => {
    if (!seconds) {
      action();
    }
  }, [seconds, action]);

  useEffect(() => {
    const timer = setInterval(ticker, TIME_INTERVAL);
    return () => {
      clearInterval(timer);
    };
  }, [ticker]);
  return seconds;
};
export default useLessMinute;
